<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2 mt-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-history</v-icon>
				履歴表示
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">成績書履歴</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="inspection_reports"
						:headers="headers"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr
								@click="!item.destroy_flag ? openDialog(item) : false"
								:class="{ 'no-click': item.destroy_flag }"
							>
								<td>{{ item.name }}</td>
								<td>{{ common.formatDate(item.created_at) }}</td>
								<td>{{ item.user.full_name }}</td>
								<td>
									<template v-if="item.destroy_flag">
										<v-icon> mdi-check</v-icon>
									</template>
								</td>
								<td>{{ item.destroy_user ? item.destroy_user.full_name : "" }}</td>
								<td>{{ common.formatDate(item.destroy_date) }}</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-sheet>
		</v-card>
		<InspectionReportShowDialog
			:dialog.sync="inspectionReportShowDialog"
			:inspection_report="selectedInspectionReport"
			:authority_flag="authority_flag"
			@update-inspection-report="updateInspectionReport($event)"
			@delete-inspection-report="deleteInspectionReport($event)"
		/>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
import InspectionReportShowDialog from "./InspectionReportShowDialog.vue"

export default {
	props: {
		inspection_reports: {
			type: Array,
			default: () => [],
		},
		authority_flag: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		InspectionReportShowDialog,
	},
	data() {
		return {
			common,
			dialog: false,
			selectedInspectionReport: {
				id: null,
				name: null,
				created_at: null,
				user: {
					full_name: null,
				},
			},
			inspectionReportShowDialog: false,
			headers: [
				{ text: "ファイル名", value: "name", width: "200px" },
				{ text: "登録日", value: "created_at", width: "120px" },
				{ text: "登録者", value: "user.full_name", width: "120px" },
				{ text: "削除済み", value: "destroy_flag", width: "80px" },
				{ text: "削除者", value: "destroy_user.full_name", width: "120px" },
				{ text: "削除日", value: "destroy_date", width: "125px" },
			],
		}
	},
	methods: {
		openDialog(item) {
			this.selectedInspectionReport = item
			this.inspectionReportShowDialog = true
		},
		updateInspectionReport(inspection_report) {
			// TODO
			const found_inspection_report = this.inspection_reports.find((item) => {
				return item.id == inspection_report.id
			})
			if (found_inspection_report) found_inspection_report.name = inspection_report.name
			this.$emit("update-inspection-report", inspection_report)
		},
		deleteInspectionReport(inspection_report) {
			// TODO
			let index = this.inspection_reports.findIndex((item) => item.id == inspection_report.id)
			if (index !== -1) {
				this.inspection_reports.splice(index, 1, inspection_report)
				this.$emit("delete-inspection-report", inspection_report)
			}
		},
	},
}
</script>
